export default __webpack_public_path__ + "static/media/Maskgroup5.3b22755d.svg";